import {State} from '@ngxs/store';
import {AdvertiserCampaignsModel} from './advertiser-campaigns.model';
import {AdvertiserCampaignEnum} from '@shared/enums/advertiser-campaign.enum';
import {Observable} from 'rxjs';
import {AdvertiserCampaignService} from '../../services-advertiser/campaign/campaign.service';
import {tap} from 'rxjs/operators';
import {IResponse} from '@interfaces/response';
import {ICampaignActiveScheduled, ICampaignHistory, ICampaignSaved} from '@interfaces/advertiser/campaign';
import {CampaignsSortType} from '../../types/campaigns.type';
import {OrderType} from '../../types/order.type';
import {Injectable} from '@angular/core';
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

@StateRepository()
@State<AdvertiserCampaignsModel>({
  name: 'advertiserCampaignsState',
  defaults: {
    currentPage: 1,
    searchParam: '',
    order: 'DESC',
    itemsPerPage: 10,
    total: 0,
    loader: false,
    sort: 'id',
    campaigns: [],
    type: AdvertiserCampaignEnum.new,
    savedCampaignId: null
  }
})

@Injectable()
export class AdvertiserCampaignsState extends NgxsDataRepository<AdvertiserCampaignsModel> {
  constructor(private campaignService: AdvertiserCampaignService) {
    super();
  }

  @DataActionWithoutSubscription({cancelUncompleted: true})
  fetchCampaigns(): Observable<IResponse<ICampaignSaved | ICampaignActiveScheduled | ICampaignHistory>> {
    const limit = this.ctx.getState().itemsPerPage;
    const skip = limit * (this.ctx.getState().currentPage - 1);
    const search = this.ctx.getState().searchParam;
    const order = this.ctx.getState().order;
    const sort = this.ctx.getState().sort;
    const type = this.ctx.getState().type;

    this.ctx.patchState({loader: true});
    return this.campaignService.getAdvertiserCampaigns(type, {limit, skip, search, order, sort})
      .pipe(
        tap((data) => {
          const state = this.ctx.getState();
          this.ctx.setState({...state, campaigns: data.rows, loader: false, total: data.count});
        })
      );
  }

  @DataActionWithoutSubscription()
  getCampaignsByType(@Payload('[Advertiser campaigns state] get campaigns by type') type: AdvertiserCampaignEnum): Observable<any> {
    this.ctx.patchState({type, currentPage: 1, searchParam: '', campaigns: []});
    return this.fetchCampaigns();
  }

  @DataActionWithoutSubscription()
  searchCampaigns(@Payload('[Advertiser campaigns state] search campaigns') search: string): Observable<any> {
    this.ctx.patchState({searchParam: search, currentPage: 1});
    return this.fetchCampaigns();
  }

  @DataActionWithoutSubscription()
  sortCampaigns(@Payload('[Advertiser campaigns state] search campaigns') payload: { sort: CampaignsSortType, order: OrderType })
    : Observable<any> {
    this.ctx.patchState({order: payload.order, sort: payload.sort});
    return this.fetchCampaigns();
  }

  @DataActionWithoutSubscription()
  getCampaignsByPage(@Payload('[Advertiser campaigns state] get campaigns by page') page: number): Observable<any> {
    this.ctx.patchState({currentPage: page});
    return this.fetchCampaigns();
  }

  @DataActionWithoutSubscription()
  setSavedCampaignId(@Payload('[Advertiser campaigns state] set active saved campaign id') id: number | null): void {
    this.ctx.patchState({savedCampaignId: id});
  }
}
